import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = `${config.backendUrl}`;

export const updateProjectDueDate = createAsyncThunk(
  "project/updateProjectDueDate",
  async ({ id, ProjectDueDate }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${BackendURL}/project-assigned/update-duedate/${id}`,
        { ProjectDueDate },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.data; // returning updated project
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update Project Due Date"
      );
    }
  }
);

export const updateAllProjectDueDatesByQuotationId = createAsyncThunk(
  "project/updateAllProjectDueDatesByQuotationId",
  async ({ quotationId, ProjectDueDate }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${BackendURL}/project-assigned/updateall-due-date`,
        { quotationId, ProjectDueDate },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data; // includes message, updatedCount, newDueDate
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        "Failed to update Project Due Dates by quotationId"
      );
    }
  }
);


const projectDueDateSlice = createSlice({
  name: "projectDueDate",
  initialState: {
    loading: false,
    success: false,
    error: null,
    updatedProject: null,
  },
  reducers: {
    clearProjectDueDateState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.updatedProject = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateProjectDueDate.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateProjectDueDate.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedProject = action.payload;
      })
      .addCase(updateProjectDueDate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })

      .addCase(updateAllProjectDueDatesByQuotationId.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateAllProjectDueDatesByQuotationId.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedProject = action.payload; // contains message, count, etc.
      })
      .addCase(updateAllProjectDueDatesByQuotationId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }

});

export const { clearProjectDueDateState } = projectDueDateSlice.actions;

export default projectDueDateSlice.reducer;


